import React from 'react';
import NoDataOverlay from './no-data-overlay';

export function createGridOverlays(
  baseTitle: string,
  icon: React.ReactNode,
  messageForNoRows?: string,
  messageForNoResults?: string,
  isErrorOverlay: boolean = false
) {
  const displayedTitle =
    baseTitle !== null && baseTitle !== ''
      ? baseTitle === 'Search Above' || isErrorOverlay
        ? baseTitle
        : `No ${baseTitle} Found`
      : '';

  const OverlayNoRows = () => (
    <NoDataOverlay
      title={displayedTitle}
      icon={icon}
      message={messageForNoRows || ''}
    />
  );

  const OverlayNoResults = () => (
    <NoDataOverlay
      title={displayedTitle}
      icon={icon}
      message={messageForNoResults || 'Try updating your search or filters.'}
    />
  );

  return {
    noRowsOverlay: OverlayNoRows,
    noResultsOverlay: OverlayNoResults,
  };
}
